import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { GradingSuggestionDto } from "./grade-suggestion.dto";

export class GradeSuggestionResponse extends GlobalResponseObject{

      data?: GradingSuggestionDto;
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, intlCode:number, internalMessage:string, data?: GradingSuggestionDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.internalMessage = internalMessage;
        this.intlCode = intlCode;
        this.data = data;
    }

}